import { render } from "./PlashkaModal.vue?vue&type=template&id=da4bfeb4&scoped=true"
import script from "./PlashkaModal.vue?vue&type=script&lang=js"
export * from "./PlashkaModal.vue?vue&type=script&lang=js"

import "./PlashkaModal.vue?vue&type=style&index=0&id=da4bfeb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4bfeb4"]])

export default __exports__